/**
 * @param {object} opts
 * @param {string} opts.itemName
 */
const getSessionItem = (opts = {}) => {
  if (!opts.itemName) {
    return {};
  }
  try {
    if (typeof sessionStorage === 'undefined' || sessionStorage === null) {
      return null;
    }
    const itemValue = sessionStorage.getItem(opts.itemName);
    return itemValue ? JSON.parse(itemValue) : {};
  } catch (err) {
    return null;
  }
};

export default getSessionItem;
